/*
|-------------------------------------------------------------------------------
| API modules/associations/index.js
|-------------------------------------------------------------------------------
| The Vuex data store for associations that may belong to the user
*/

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export const associations = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
